import { useMemo } from 'react';
import { useAuth } from './useAuth';

export function usePermissions() {
  const { user } = useAuth();

  const permissionSet = useMemo(() => {
    const permissions = user?.role?.permissions ?? [];
    return new Set(permissions.map((permission) => permission.name));
  }, [user]);

  const hasPermission = (required: string | string[]): boolean => {
    if (!required || (Array.isArray(required) && required.length === 0)) {
      return true;
    }

    const requiredArray = Array.isArray(required) ? required : [required];
    return requiredArray.some((permission) => permissionSet.has(permission));
  };

  const hasAllPermissions = (required: string[]): boolean => {
    if (!required || required.length === 0) {
      return true;
    }

    return required.every((permission) => permissionSet.has(permission));
  };

  return {
    hasPermission,
    hasAllPermissions,
    permissions: permissionSet,
    user,
  };
}
